export function UploadIconEnd() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_228_1165)">
        <rect width="40" height="40" rx="20" fill="#1131F5"/>
        <path d="M20 14.1667V25.8334" stroke="white" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M14.1667 20H25.8334" stroke="white" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_i_228_1165" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_innerShadow_228_1165"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="6"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_228_1165"/>
        </filter>
      </defs>
    </svg>
  )
}